import { render } from "./catBox.vue?vue&type=template&id=04b5e3e6"
import script from "./catBox.vue?vue&type=script&lang=js"
export * from "./catBox.vue?vue&type=script&lang=js"

import "./catBox.vue?vue&type=style&index=0&id=04b5e3e6&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__